var map = {
	"./illustration-success.png": 228,
	"./image-catalog-1.png": 5306,
	"./image-catalog-2.png": 6138,
	"./image-catalog-3.png": 8209,
	"./image-catalog-4.png": 257,
	"./image-section-1.png": 6297,
	"./logo.png": 4427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;